import script from "./MetadataPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MetadataPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__